import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHeader } from "@/components/Layout";
import { api, fmtDate, gbp } from "@/lib/api";

const PILL = { paid: "text-emerald-700 bg-emerald-50 border-emerald-200", pending: "text-amber-700 bg-amber-50 border-amber-200" };

export default function Receipts() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/receipts").then((r) => setRows(r.data));
  }, []);
  return (
    <div data-testid="receipts-page">
      <PageHeader eyebrow="Billing" title="Receipts" />
      {rows && !rows.length && <p data-testid="receipts-empty" className="text-sm text-slate-500">No payments yet.</p>}
      {rows && rows.length > 0 && (
        <div className="overflow-x-auto rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900">
          <table className="w-full text-sm" data-testid="receipts-table">
            <thead><tr className="text-left text-[11px] uppercase tracking-wider text-slate-500 border-b border-slate-200 dark:border-slate-800">
              {["Date", "Letter", "Amount", "Status", "Stripe session"].map((h) => <th key={h} className="px-4 py-3 font-semibold">{h}</th>)}
            </tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.session_id} className="border-b last:border-0 border-slate-100 dark:border-slate-800">
                  <td className="px-4 py-3 font-mono text-xs whitespace-nowrap">{fmtDate(r.created_at)}</td>
                  <td className="px-4 py-3 font-mono text-xs"><Link to={`/app/mail/${r.mail_id}`} className="text-emerald-700 dark:text-emerald-400 hover:underline">{r.reference}</Link></td>
                  <td className="px-4 py-3">{gbp(r.amount)}</td>
                  <td className="px-4 py-3"><span data-testid={`receipt-status-${r.reference}`} className={`px-2 py-0.5 rounded-md border text-xs ${PILL[r.payment_status] || "text-slate-600 bg-slate-50 border-slate-200"}`}>{r.payment_status}</span></td>
                  <td className="px-4 py-3 font-mono text-[11px] text-slate-500 max-w-[200px] truncate">{r.session_id}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
